import { render, staticRenderFns } from "./ConventionAdminTools.vue?vue&type=template&id=bdff0b12&scoped=true"
import script from "./ConventionAdminTools.vue?vue&type=script&lang=js"
export * from "./ConventionAdminTools.vue?vue&type=script&lang=js"
import style0 from "./ConventionAdminTools.vue?vue&type=style&index=0&id=bdff0b12&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff0b12",
  null
  
)

export default component.exports